export default __webpack_public_path__ + "static/media/exit.e5382f95.svg";